// Library import
import {useEffect, useState} from 'react';
import {Alert, Modal} from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import LogoutIcon from '~/images/icon/Icon.svg';
import {AuthApi} from '@/http';

export const LogoutModal = ({show, handleClose}) => {
    const [serverError, setServerError] = useState('');
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    //   Logout user handle
    const handleLogoutSubmit = async (event) => {
        event.preventDefault();

        try {
            setDisableSubmitBtn(true);
            const response = await AuthApi.logout();

            if (response.status === 200) {
                setDisableSubmitBtn(true);
                setTimeout(() => {
                    window.open(`/admin/login`, '_self');
                }, 1000);
            }
        } catch (error) {
            setDisableSubmitBtn(false);
            setServerError('Server error occured !');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
            <div className='p-5'>
                <div className='modal-common-content text-center'>
                    <img src={LogoutIcon} alt='Icon' />
                    <p className='text my-4'>ログアウト</p>
                    <p className='text my-4'>ログアウトします。宜しいですか？</p>

                    <div className='action-btn d-flex justify-content-center align-items-center'>
                        <button className='button primary' disabled={disableSubmitBtn}
                                onClick={(event) => handleLogoutSubmit(event)}>
                            ログアウト
                        </button>
                        <button className='button outline' onClick={handleClose}>
                            キャンセル
                        </button>
                    </div>
                </div>

                {/* Server error */}
                {serverError && <Alert variant='danger'>{serverError}</Alert>}

                <div className='close-modal' onClick={handleClose}>
                    <img src={CrossIcon} alt='Cross icon'/>
                </div>
            </div>
        </Modal>
    );
};

LogoutModal.prototype = {
    show: Proptypes.bool,
    handleClose: Proptypes.func,
};
